import { useState, useEffect } from "react";
import Loading from "../Components/Loading";
import * as api from "../api/api";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import checkAuthorization from "../config/checkAuth";
import { Snackbar, Alert } from "@mui/material";
import { useLanguage } from "../Components/Localization/LanguageContext";
import strings from "../Components/Localization/strings";

export default function InboundVDNs() {
  const { language } = useLanguage();
  const pageTitle = "InboundVDNs";

  const [snackbarData, setSnackbarData] = useState({});

  function handleAddVdn() {
    setShow(true);
  }

  const [inboundVdnCreation, setInboundVdnCreation] = useState({});
  const [vdns, setVDNs] = useState([]);
  const [lobs, setLobs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setInboundVdnCreation({});
  };
  const [isEditingVdn, setIsEditingVdn] = useState(false);
  const [inboundVdnEdit, setInboundVdnEdit] = useState({});
  const [validatedAddVdn, setValidatedAddVdn] = useState(false);
  const [validatedEditVdn, setValidatedEditVdn] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [vdnToDeleteId, setVdnToDeleteId] = useState("");

  const navigate = useNavigate();

  function handleDataChangeName(event) {
    setInboundVdnCreation({
      ...inboundVdnCreation,
      name: event.target.value,
    });
  }

  function handleDataChangeIniVdn(event) {
    setInboundVdnCreation({
      ...inboundVdnCreation,
      vdn: event.target.value,
    });
  }

  function handleDataChangeLob(event) {
    console.log(event.target.value);
    setInboundVdnCreation({
      ...inboundVdnCreation,
      lineOfBusiness: event.target.value,
    });
  }

  function handleEditingChangeName(event) {
    setInboundVdnEdit({
      ...inboundVdnEdit,
      name: event.target.value,
    });
  }

  function handleEditingChangeIniVdn(event) {
    setInboundVdnEdit({
      ...inboundVdnEdit,
      vdn: event.target.value,
    });
  }

  function handleEditingChangeLob(event) {
    console.log(event.target.value);
    setInboundVdnEdit({
      ...inboundVdnEdit,
      lineOfBusiness: event.target.value,
    });
  }

  function getInboundVdns() {
    api.getInboundVdns().then((response) => {
      setVDNs(response.data.object);
      // order vdns
      vdns.sort((a, b) => (a.position > b.position ? 1 : -1));
    });
  }

  function getAllLobs() {
    api.getAllLobs().then((response) => {
      setLobs(response.data.object);
      setInboundVdnCreation({
        ...inboundVdnCreation,
      });
    });
  }

  function addNewInboundVdn(event) {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setValidatedAddVdn(true);
      event.preventDefault();
      const payload = { ...inboundVdnCreation, position: vdns.length };
      api
        .addNewVdn(payload)
        .then((response) => {
          console.log(response);

          if (response.data.statusCode == 400) {
            setSnackbarData({
              ...snackbarData,
              message: response.data.message,
              severity: "error",
              show: true,
            });
          } else if (response.data.statusCode == 200) {
            getInboundVdns();
            setSnackbarData({
              ...snackbarData,
              message: "Created new inbound queue successfully",
              show: true,
              severity: "success",
            });
            setShow(false);
            setInboundVdnCreation({});
          }
        })
        .catch((error) => {
          console.log("error");
        });
    }
    setValidatedAddVdn(true);
  }

  function deleteInboundVdn(id) {
    console.log(id);
    api.deleteVdn(id).then((response) => {
      console.log(response);
      setShowConfirmDeleteModal(false);
      if (response.data.statusCode == 200) {
        setSnackbarData({
          ...snackbarData,
          message: "Deleted inbound queue successfully",
          show: true,
          severity: "success",
        });
        getInboundVdns();
      }
    });
  }

  function editInboundVdn(event) {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      console.log(inboundVdnEdit);
      event.preventDefault();

      api
        .modifyInboundVdn(inboundVdnEdit.inboundVdnId, inboundVdnEdit)
        .then((response) => {
          console.log(response);
          setIsEditingVdn(false);
          if (response.data.statusCode == 200) {
            getInboundVdns();
            setSnackbarData({
              ...snackbarData,
              message: "Edited inbound queue successfully",
              show: true,
              severity: "success",
            });
          }
        })
        .catch((error) => console.log(error));
    }
    setValidatedEditVdn(true);
  }

  function sortFormPositions(a, b) {
    if (a.position < b.position) {
      return -1;
    } else if (a.position > b.position) {
      return 1;
    } else {
      return 0;
    }
  }

  useEffect(() => {
    checkAuthorization("INBOUND_VDN").then((result) => {
      if (result) {
        if (isLoading) {
          getInboundVdns();
          getAllLobs();
          setIsLoading(false);
        } else {
        }
        //console.log(vdns);
      } else {
        navigate("/unauthorized");
      }
    });
  });

  return (
    <>
      <div className="main-content">
        <p className="main-content__title">
          {strings[pageTitle][language].pageName}
        </p>
        <hr className="main-content-title__hr" />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={snackbarData.show}
          autoHideDuration={3000}
          onClose={() => setSnackbarData({ ...snackbarData, show: false })}
        >
          <Alert severity={snackbarData.severity}>{snackbarData.message}</Alert>
        </Snackbar>

        <div
          style={{
            display: "flex",
            justifyContent: "end",
            flexDirection: "row",
          }}
        >
          <button className="btn btn-outline-primary" onClick={handleAddVdn}>
            {strings[pageTitle][language].add}
          </button>
        </div>

        {isLoading ? (
          <Loading></Loading>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "row",
            }}
          >
            <table
              style={{
                width: "100%",
                marginTop: 20,
                border: "none",
              }}
            >
              <thead>
                <tr align={"left"}>
                  <th>{strings[pageTitle][language].tableHeaders[0]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[1]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[2]}</th>
                  <th>{strings[pageTitle][language].tableHeaders[3]}</th>
                </tr>
              </thead>
              <tbody>
                {vdns.sort(sortFormPositions).map((vdn) => {
                  return (
                    <tr key={vdn.inboundVdnId}>
                      <td>{vdn.name}</td>
                      <td>{vdn.vdn}</td>
                      <td>{vdn.lineOfBusiness}</td>
                      <td style={{ display: "flex" }} align="center">
                        <button
                          style={{
                            border: "none",
                            outline: "none",
                            backgroundColor: "rgba(255, 0, 0, 0)",
                            color: "#00a0e5",
                          }}
                          className="icon-btn"
                          onClick={() => {
                            setIsEditingVdn(true);
                            setInboundVdnEdit({
                              name: vdn.name,
                              inboundVdnId: vdn.inboundVdnId,
                              lineOfBusiness: vdn.lineOfBusiness,
                              vdn: vdn.vdn,
                            });

                            console.log(inboundVdnEdit);
                          }}
                        >
                          <EditIcon></EditIcon>
                        </button>
                        <button
                          style={{
                            border: "none",
                            outline: "none",
                            backgroundColor: "rgba(255, 0, 0, 0)",
                            color: "#00a0e5",
                          }}
                          className="icon-btn"
                          onClick={() => {
                            setShowConfirmDeleteModal(true);
                            setVdnToDeleteId(vdn.inboundVdnId);
                          }}
                        >
                          <DeleteIcon></DeleteIcon>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
      <Modal show={show} onHide={handleClose}>
        <Form onSubmit={addNewInboundVdn}>
          <Modal.Body>
            <b>{strings[pageTitle][language].addNewInboundQueue}</b>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].name}</Form.Label>
              <Form.Control
                placeholder=""
                autoFocus
                onChange={(event) => handleDataChangeName(event)}
                required
                type="text"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].iniQueue}</Form.Label>
              <Form.Control
                placeholder=""
                onChange={handleDataChangeIniVdn}
                required
                type="text"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                {strings[pageTitle][language].lineOfBusiness}
              </Form.Label>
              <Form.Select onChange={handleDataChangeLob}>
                <option> </option>
                {lobs.map((lob) => {
                  return (
                    <option value={lob.name} key={lob.id}>
                      {lob.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setShow(false);
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].add}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={isEditingVdn}>
        <Form onSubmit={editInboundVdn} noValidate validated={validatedEditVdn}>
          <Modal.Body>
            <b>{strings[pageTitle][language].editInboundQueue}</b>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].name}</Form.Label>
              <Form.Control
                defaultValue={inboundVdnEdit.name}
                autoFocus
                onChange={(event) => handleEditingChangeName(event)}
                required
                type="text"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>{strings[pageTitle][language].iniQueue}</Form.Label>
              <Form.Control
                defaultValue={inboundVdnEdit.vdn}
                onChange={handleEditingChangeIniVdn}
                required
                type="text"
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>
                {strings[pageTitle][language].lineOfBusiness}
              </Form.Label>
              <Form.Select
                className="form-select"
                aria-label="Default select example"
                onChange={handleEditingChangeLob}
                defaultValue={inboundVdnEdit.lineOfBusiness}
              >
                <option> </option>

                {lobs.map((lob) => {
                  return (
                    <option value={lob.name} key={lob.id}>
                      {lob.name}
                    </option>
                  );
                })}
              </Form.Select>
            </Form.Group>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setIsEditingVdn(false);
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button variant="primary" type="submit">
              {strings[pageTitle][language].confirm}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showConfirmDeleteModal}>
        <Modal.Body>
          <p>{strings[pageTitle][language].deleteConfirmation}</p>
          <Modal.Footer>
            <Button
              variant="light"
              onClick={() => {
                setShowConfirmDeleteModal(false);
              }}
            >
              {strings[pageTitle][language].cancel}
            </Button>
            <Button
              variant="danger"
              onClick={() => deleteInboundVdn(vdnToDeleteId)}
            >
              {strings[pageTitle][language].confirm}
            </Button>
          </Modal.Footer>
        </Modal.Body>
      </Modal>
    </>
  );
}
